import React from "react";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { TooltipTarget } from "../../../../uiModel/tooltip/TooltipTarget";
import { MenuButtonComponent } from "../common/MenuButtonComponent";

import "@styles/c-menuButtonWithTooltip.scss";

interface Props {
  onClick: (event: React.MouseEvent) => void;
  icon: React.ReactNode;
  isDisabled?: boolean;
  isActive?: boolean;
  className?: string;

  isTooltipDisabled?: boolean;
  tooltipTarget: TooltipTarget;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
  onCancelTooltip: () => void;
}

export class MenuButtonWithTooltipComponent extends React.Component<Props> {

  render() {
    const {
      onClick,
      icon,
      isActive,
      isDisabled,
      className,
      onCancelTooltip
    } = this.props;

    return (
      <div
        className={`c-menuButtonWithTooltip ${className || ""}`}
        onMouseEnter={(event) => this.handleMouseEnter(event)}
        onMouseLeave={onCancelTooltip}
      >
        <MenuButtonComponent
          onClick={onClick}
          icon={icon}
          isDesktop={true}
          isActive={isActive}
          isDisabled={isDisabled}
          className="c-menuButtonWithTooltip__button"
        />
      </div>

    );
  }

  private handleMouseEnter(event: React.MouseEvent) {
    if (!this.props.isTooltipDisabled) {
      const boundingBox = (event.target as HTMLElement).getBoundingClientRect();
      this.props.onRequestTooltip({
        x: boundingBox.left + boundingBox.width / 2,
        y: boundingBox.top,
        target: this.props.tooltipTarget
      });
    }
  }
}
